import {useEffect, useMemo, useState} from 'react';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';

import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';

import FormControl from '@mui/material/FormControl';

import Slide from '@mui/material/Slide';

// import {useConfigStore} from '../../../Stores/config';
import {useFormStore} from '../../../Stores/form';

import CurrencyFormated from '../../CurrencyFormated'

import Text from '../Text';
// import JSONEditor from '../JSONEditor';
import Number from '../Number';
import Checkbox from '../Checkbox';
import JSONEditor from '../JSONEditor';

import './index.scss';

export default function PriceAndPayments(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    const [newValuePrice, setNewValuePrice] = useState();
    const [newValueDetails, setNewValueDetails] = useState();
    const [newDefault, setNewDefault] = useState(false);
    const [newValueCurrency, setNewValueCurrency] = useState();
    const [newValueType, setNewValueType] = useState();
    const [addPaymentShow, setAddPaymentShow] = useState();
    const [valueDiscounts, setValueDiscounts] = useState(isEditMode ? content?.[field.id]?.discounts : {});
    const [valuePre, setValuePre] = useState(isEditMode ? content?.[field.id]?.pre : "Для реєстраціїї необхідно внести організаційний збір");
    const [valueSufix, setValueSufix] = useState(isEditMode ? content?.[field.id]?.sufix : "та прикріпити скріншот з підтвердженням про сплату");
    const [valueNotes1, setValueNotes1] = useState(isEditMode ? content?.[field.id]?.notes1 : "📍 локацію ви отримаєте одразу після реєстрації. Район проведення вказано в описі до події");
    const [valueNotes2, setValueNotes2] = useState(isEditMode ? content?.[field.id]?.notes2 : "💵 готівка та сплата на місці не приймається");
    
    const [addedPaymentTypes, setAddedPaymentTypes] = useState([]);

    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    useEffect(() => {
        const types = content?.[field.id]?.values?.map(i => i.type);
        setAddedPaymentTypes(types || []);
        console.log(isEditMode)
        // setValuePre(content?.[field.id]?.pre);
        // if (isEditMode) {
        //     setValuePre(content?.[field.id]?.pre);
        // }
        // else {
        //     // if (!content?.[field.id]?.pre)
        //     // setValuePre("Для реєстраціїї необхідно внести організаційний збір");
        // }
    }, [content[field.id]])

    const paymentOptionsLists = [
        {
            key: "ua-card",
            placeholder: "💳 Переказ на українську картку",
            currency: "uah"
        },
        {
            key: "usdt-trc20",
            placeholder: "🔐 USDT TRC20 гаманець",
            currency: "usdt"
        },
        {
            key: "mono-link",
            placeholder: "🫙 Монобанка",
            currency: "uah"
        },
        {
            key: "indo-card",
            placeholder: "🇮🇩 Permata",
            currency: "idr"
        }
    ]

    const className = useMemo(() => {
        return 'PriceAndPayments'
            + (isDisabled ? ' disabled' : '')
            + (showErrorText ? ' error' : '')
    }, [isDisabled, showErrorText, field]);

    const onNewValuePriceChange = (e) => {
        setNewValuePrice(e.target.value);
    }

    const onNewValueDefaultChange = (e) => {
        if (e.target.checked) {
            setNewDefault(true)
        }
        else {
            setNewDefault(false)
        }
    }

    const onNewValueDetailsChange = (e) => {
        setNewValueDetails(e.target.value);
    }

    const onValuePreChange = (e) => {
        setValuePre(e.target.value);
        onChange({target: {value: {...content[field.id], pre: e.target.value}}})
    }

    const onValueSufixChange = (e) => {
        setValueSufix(e.target.value);
        onChange({target: {value: {...content[field.id], sufix: e.target.value}}})
    }

    const onValueNotes1Change = (e) => {
        setValueNotes1(e.target.value);
        onChange({target: {value: {...content[field.id], notes1: e.target.value}}})
    }

    const onValueNotes2Change = (e) => {
        setValueNotes2(e.target.value);
        onChange({target: {value: {...content[field.id], notes2: e.target.value}}})
    }

    const onValueDiscountsChange = (e) => {
        if (e?.src) {
            // console.log(e.src)
            setValueDiscounts(e.src);
            onChange({target: {value: {...content[field.id], discounts: e.src}}})
        }
    }

    // const onValueNotesChange = (e) => {
    //     setValueNotes(e.target.value);
    //     onChange({target: {value: {...content[field.id], notes: e.target.value}}})
    // }

    const onNewValueTypeChange = (e) => {
        const value = e.target.value;
        setNewValueType(value);
        let cur = paymentOptionsLists.find(o => o.key === value)?.currency
        setNewValueCurrency(cur);
    }

    const onAddPriceAndPaymentsHandle = () => {
        if (!newValueType || !newValuePrice || !newValueCurrency || !newValueDetails) return;

        const value = content[field.id] || {};

        if (valuePre) value.pre = valuePre;

        value.values = value.values || [];
        const config = {
            type: newValueType,
            price: newValuePrice,
            details: newValueDetails
        }
        if (newDefault) config.default = true;
        value.values.push(config);

        const newAddedPaymentTypes = [...addedPaymentTypes];
        newAddedPaymentTypes.push(newValueType);
        setAddedPaymentTypes(newAddedPaymentTypes);

        setNewValueType(undefined);
        setNewValuePrice(undefined);
        setNewValueDetails(undefined);
        setNewValueCurrency(undefined);
        setNewDefault(false);

        setAddPaymentShow(false)

        onChange({target: {value}})
    }

    const onRemoveHandle = (id) => {
        const value = content[field.id] || {};

        const i = value?.values?.findIndex(i => i.type === id);
        if (i > -1) { value.values.splice(i, 1); }

        onChange({target: {value}});

        const newAddedPaymentTypes = [...addedPaymentTypes];
        const ni = newAddedPaymentTypes?.findIndex(i => i === id);
        if (ni > -1) { newAddedPaymentTypes.splice(ni, 1); }
        setAddedPaymentTypes(newAddedPaymentTypes);
    }

    const addPaymentMethod = () => {
        setAddPaymentShow(!addPaymentShow)
    }

    const getCurrency = (key) => {
        let result
        switch (key) {
            case "ua-card":
                result = "UAH";
                break;
            case "usdt-trc20":
                result = "USDT";
                break;
            case "mono-link":
                result = "UAH";
                break;
            case "indo-card":
                result = "IDR";
                break;
        }
        return result
    }

    const paymentDemoAmount = 1;

    return <div className={className}>
    <div className="pseudoInput priceInputEmulation">
        <div className='inputLabel'>
            {field.placeholder} {field.required ? '*' : ''}
        </div>

        <div className='multiPriceTable'>

            <p>Методи сплати:</p>
            {content[field.id]?.values?.length > 0 && <div className='multiPriceTableWrap'>{content[field.id]?.values?.map(i =>
                <Grid container spacing={1} key={`multi_prices_item_${i.id}`}>
                    <Grid item xs={12}>
                        <div className='item'>
                            {paymentOptionsLists.find(o => o.key === i.type)?.placeholder}
                            :&nbsp;
                            {<CurrencyFormated value={i.price} currency={getCurrency(i.type)} />}

                            <div className='details'>{i.details}</div>
                            {i.default && <div className='default'>✅ Значення за замовченням</div>}
                            {i.pre && <div className='pre'>Підпис: {i.pre}</div>}

                            <ClearIcon className='remove' onClick={() => onRemoveHandle(i.type)}/>
                        </div>
                    </Grid>
                </Grid>
            )}</div>}

            {addedPaymentTypes?.length !== paymentOptionsLists?.length && <>
                <div><span className='pseudoLink' onClick={addPaymentMethod}>Додати метод оплати</span></div>

                <Slide in={addPaymentShow} mountOnEnter unmountOnExit>
                    <div className='paymentMethodsForm'>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                                <FormControl disabled={isDisabled} fullWidth>
                                    <InputLabel>Тип платежу</InputLabel>
                                    <Select
                                        disabled={isDisabled}
                                        label="Тип платежу"
                                        value={newValueType}
                                        onChange={onNewValueTypeChange}>
                                            {paymentOptionsLists.filter(i => !addedPaymentTypes.includes(i.key)).map(item => <MenuItem key={item.key} value={item.key}>
                                                {item.placeholder.toUpperCase()}
                                            </MenuItem>)}
                                    </Select>
                                </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Text
                                disabled={isDisabled}
                                field={{id: 'details', placeholder: "Реквізити"}}
                                content={{details: newValueDetails}}
                                onChange={onNewValueDetailsChange}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Number
                                        disabled={isDisabled}
                                        field={{id: 'price', placeholder: "Ціна", options: {sufix: newValueCurrency?.toUpperCase()}}}
                                        content={{price: newValuePrice}}
                                        onChange={onNewValuePriceChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Checkbox
                                        field={{id: 'default', placeholder: "За замовченням"}}
                                        content={{default: newDefault}}
                                        onChange={onNewValueDefaultChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                fullWidth
                                // className={actionClassName}
                                variant="outlined"
                                component="label"
                                tabIndex={-1}
                                onClick={onAddPriceAndPaymentsHandle}
                            >
                                <AddIcon />
                                <span>Додати</span>
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                    </div>
                </Slide>
            </>}

            <br/>
            <p>Підказка під час реєстрації:</p>
            <Grid container spacing={2}>
                <Text
                    disabled={isDisabled}
                    field={{id: 'pre', placeholder: "Текст до", required: true}}
                    content={{pre: valuePre}}
                    onChange={onValuePreChange}
                />
                <Text
                    disabled={isDisabled}
                    field={{id: 'sufix', placeholder: "Текст після", required: true}}
                    content={{sufix: valueSufix}}
                    onChange={onValueSufixChange}
                />
                <Text
                    disabled={isDisabled}
                    field={{id: 'notes1', placeholder: "Примітка 1", required: true}}
                    content={{notes1: valueNotes1}}
                    onChange={onValueNotes1Change}
                />
                <Text
                    disabled={isDisabled}
                    field={{id: 'notes2', placeholder: "Примітка 2", required: true}}
                    content={{notes2: valueNotes2}}
                    onChange={onValueNotes2Change}
                />
                {/* <JSONEditor
                    disabled={isDisabled}
                    field={{id: 'notes', placeholder: "Примітки", required: true}}
                    content={{notes: valueNotes}}
                    onChange={onValueNotesChange}
                /> */}
            </Grid>

            <div className='paymentMethodsDemo'>
                {valuePre} за {paymentDemoAmount} {paymentDemoAmount === 1 ? "особу" : paymentDemoAmount < 5 ? "особи" : "осіб"} {valueSufix}
                &nbsp;
                <CurrencyFormated value={paymentDemoAmount * 100} currency={"UAH"} />
                <div className='notes'>
                    {valueNotes1 && <p>{valueNotes1}</p>}
                    {valueNotes2 && <p>{valueNotes2}</p>}
                </div>
            </div>

            <JSONEditor
                disabled={isDisabled}
                field={{id: 'discounts', placeholder: "Промокоди", notes: "{promo_code: {type: \"percent|value|price\", value: 10}}"}}
                content={{discounts: valueDiscounts}}
                onChange={onValueDiscountsChange}
            />
        </div>
    </div>

    {!showErrorText && field?.notes && <div className='fieldNotes'>
        <p>{field?.notes}</p>
    </div>}
    {showErrorText && <div className='fieldError'>
        {showErrorText}
    </div>}
</div>
}
